// document.documentElement.style.setProperty('--primary', '#C8BCA4');

// window.dataLayer = window.dataLayer || [];
// function gtag() {
//     dataLayer.push(arguments);
// }

// window.onbeforeunload = function () {
//     if (window.location.href.includes('collections')) window.scrollTo(0, 0);
// };

// if (window.location.pathname.includes('/apps/configurator')) {
//     window.location.href = 'https://kas20.nl/?open-configurator=tafel';
//     Swal.fire({
//         html: `<h3>Doorverwijzen naar nieuwe configurator...</h3>`,
//         didOpen: () => {
//             Swal.showLoading();
//         },
//         allowEnterKey: false,
//         allowOutsideClick: false,
//         allowEscapeKey: false,
//     });
//     // Swal.fire({
//     //     width: 700,
//     //     confirmButtonColor: 'var(--primary)',
//     //     showCancelButton: false,
//     //     // cancelButtonText: 'Sluiten',
//     //     html: `
//     //       <h2>Stel je eigen droomtafel samen</h2>
//     //     `,
//     //     reverseButtons: true,
//     //     confirmButtonText: 'Start nu'
//     //   })
// }

// let menuRendered = false;
// function openSidemenu() {
//     $('a[data-id="#nt_menu_canvas"]').trigger('click');
//     // $('#nt_menu_canvas').addClass('act_opened')

//     // _this.addClass('act_current');
//     $('html').addClass('hside_opened');
//     $('body').addClass('pside_opened');
//     // $id.addClass('act_opened');
//     $('.mask-overlay').addClass('mask_opened');

//     $('#nt_menu_canvas').removeClass('lazyloadt4s');
//     $('#nt_menu_canvas').addClass('lazyloadt4sed');

//     // /search/?view=mn

//     if (!menuRendered) {
//         $('#nt_menu_canvas').load($('#nt_menu_canvas').data('rendert4s'));
//     }

//     menuRendered = true;

//     //nt_fk_canvas nt_sleft dn lazyloadt4sed act_opened
//     //nt_fk_canvas nt_sleft dn lazyloadt4s act_opened
// }

// var jnStores = [
//     {
//         id: 'de-kwakel-01',
//         store_url: 'https://kas20.nl/pages/showroom-bezoeken-de-kwakel',
//         name: 'Showroom De Kwakel',
//         description: '<p class="description">Bekijk ons gehele assortiment</p>',
//         address: 'Noorddammerweg 35<br>1424 NW, De Kwakel<br>Noord-Holland',
//         store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_19_1296x.png?v=1650283399',
//         times: 'Ma 10.00 - 17.00 <br>Di 10.00 - 17.00 <br>Wo gesloten <br>Do 10.00 - 17.00 <br>Vr 10.00 - 17.00 <br>Zat 10.00 - 16.30 <br>Zo 11.00 - 13.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-de-kwakel">Feestdagen</a>',
//     },
//     {
//         id: 'amsterdam-01',
//         store_url: 'https://kas20.nl/pages/showroom-bezoeken-amsterdam',
//         name: 'Showroom Amsterdam',
//         description: '<p class="description">Bekijk ons assortiment eettafels</p>',
//         address: 'Commelinstraat 11-0<br>1019 TX, Amsterdam<br>Noord-Holland',
//         store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_20_1296x.png?v=1650283373',
//         times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vr gesloten<br>Zat 10.00 - 17.00<br>1e zondag van de maand 12:00 - 16:00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-amsterdam">Feestdagen</a>',
//     },
//     {
//         id: 'helmond-01',
//         store_url: 'https://kas20.nl/pages/showroom-bezoeken-helmond',
//         name: 'Showroom Helmond',
//         description: '<p class="description">Bekijk ons gehele assortiment</p>',
//         address: 'Nijverheidsweg 12a<br>5705 BN, Helmond<br>Noord-Brabant',
//         store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_18_1296x.png?v=1650281972',
//         times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vrij 12.00 - 16.00<br>Zat 10.00 - 16.00<br>Zo 12.00 - 16.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-helmond">Feestdagen</a>',
//     },
//     {
//         id: 'almere-01',
//         store_url: 'https://kas20.nl/pages/meubel-showroom-bezoeken-almere',
//         name: 'Showroom Almere',
//         description: '<p class="description">Bekijk ons gehele assortiment</p>',
//         address: 'Radioweg 12<br>1324 KW, Almere<br>Flevoland',
//         store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2024-02-15_at_23.41.00.jpg?v=1708036888',
//         times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/meubel-showroom-bezoeken-almere">Feestdagen</a>',
//     },
//     //                 ,{
//     //   id: 'enschede-01',
//     //   store_url: 'https://kas20.nl/pages/meubel-showroom-bezoeken-enschede',
//     //   name: 'Showroom Enschede',
//     //   description: '<p class="description">Bekijk ons gehele assortiment</p>',
//     //   address: 'Lage Bothofstraat 159A<br>7533 AS, Enschede<br>Overijssel',
//     //   store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_18_1296x.png?v=1650281972',
//     //   times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/showroom-bezoeken-almere">Feestdagen</a>',
//     // }

//     //                 ,{
//     //   id: 'rotterdam-01',
//     //   store_url: 'https://kas20.nl/pages/oud-beijerland',
//     //   name: 'Superdeals Oud-Beijerland',
//     //   description: '<p class="description">Pilotwinkel zonder personeel. Hier vind je alleen onze collectie:<br><a class="footer-btn" href="/collections/aanbieding-eettafels">Super Deals</a></p>',
//     //   address: 'Julianastraat 45<br>3226 SH, Oud-Beijerland<br>Zuid-Holland',
//     //   store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/frame-kiosk_1296x.jpg?v=1673453517',
//     //   times: 'Ma 10.00 - 17.00 <br>Di 10.00 - 17.00 <br>Wo 10.00 - 17.00 <br>Do 10.00 - 17.00 <br>Vr 10.00 - 17.00 <br>Zat 10.00 - 17.00 <br>Zo 10.00 - 17.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link" href="/pages/oud-beijerland">Feestdagen</a>',
//     // }
// ];

let jnCollectionGridReadyFired = false;

//let defaultPositions = [4,13,17,27,31];
// let defaultPositions = [3,11,16,26,30];
// let defaultPositions = [3, 11, 19, 26, 30];

let defaultPositions = [2, 13, 22];
if(window.matchMedia('(max-width: 767px)').matches) defaultPositions = [3, 14, 23]

let collectionImageCounter = 0;

window.addEventListener('globoFilterRenderCompleted', (event) => {
    //window.addEventListener("jnCollectionGridReady", event => {
    // if(typeof collectionMetadata !== 'undefined' && collectionMetadata && collectionMetadata.collection_images && collectionMetadata.collection_images.length && $('#gf-products').length > 0 && !jnCollectionGridReadyFired){

    //     //jnCollectionGridReadyFired = true;

    //   let imageLinks = [];

    //   if(collectionMetadata && collectionMetadata.collection_images_links && collectionMetadata.collection_images_links.length) imageLinks = collectionMetadata.collection_images_links;

    //     $('#gf-products > div:not(.jn-collection-banner)').each(function(index, $el){
    //         console.log(index);
    //         if(defaultPositions.length > 0 && defaultPositions.includes(index) && collectionImageCounter <= collectionMetadata.collection_images.length && collectionMetadata.collection_images[collectionImageCounter]){
    //           defaultPositions = defaultPositions.filter(a => a != index);
    //           console.log('IMAGE ADDED')
    //             if(imageLinks[collectionImageCounter] && typeof imageLinks[collectionImageCounter] === 'string' && imageLinks[collectionImageCounter].length > 2){
    //               $($el).after(`
    //                   <a href="${imageLinks[collectionImageCounter]}" class="jn-collection-banner" style="background-image:url('${collectionMetadata.collection_images[collectionImageCounter]}');">
    //                   </a>
    //               `)
    //             } else {
    //               $($el).after(`
    //                   <div class="jn-collection-banner" style="background-image:url('${collectionMetadata.collection_images[collectionImageCounter]}');">
    //                   </div>
    //               `)
    //             }

    //             if(defaultPositions.length > 0 && collectionMetadata.collection_images.length > 0){
    //               collectionImageCounter = collectionImageCounter + 1;
    //             }
    //         }
    //     })
    // }

    if (typeof collectionContentPanes !== 'undefined' && collectionContentPanes && collectionContentPanes.length > 0 && $('#gf-products').length > 0 && !jnCollectionGridReadyFired) {
        //jnCollectionGridReadyFired = true;

        $('#gf-products > div:not(.jn-collection-banner)').each(function (index, $el) {
            // console.log(index);
            if (defaultPositions.length > 0 && defaultPositions.includes(index) && collectionImageCounter <= collectionContentPanes.length && collectionContentPanes[collectionImageCounter]) {
                defaultPositions = defaultPositions.filter((a) => a != index);
                console.log('IMAGE ADDED');
                let item = collectionContentPanes[collectionImageCounter];
                console.log(item);

                if (item && typeof item !== 'undefined') {
                    $($el).after(`
                      <a href="${item.url}" class="jn-collection-banner" style="background-image:url('${item.background_image}');">
                        ${item.content ? `<div class="jn-collection-content">${item.content}</div>` : ``}
                        ${item.raw_content ? `<div class="jn-collection-raw_content">${item.raw_content}</div>` : ``}
                      </a>
                  `);
                }

                if (defaultPositions.length > 0 && collectionContentPanes.length > 0) {
                    collectionImageCounter = collectionImageCounter + 1;
                }
            }
        });
    }
});

jQuery_T4NT(document).ready(function ($) {
    let app = {
        init: () => {
            // app.removeProductPageReviews()
            app.configuratorModal.init();
            app.faq.init();
            app.goBack();
          app.readmore();
          app.futy();
          app.listenWinkelafspraak();

          app.productSwitcher.init();
        },
      listenWinkelafspraak: () => {
        if(window.location.href.includes('winkelafspraak')) return;
        if(window.location.href.includes('showroom')) return;
        
          $('body').on('click', 'a[href="/pages/winkelafspraak"]', function(e){
            e.preventDefault();
            $('.jn-btn-trigger-winkelafspraak').trigger('click')
          })
      },
      futy: () => {

         console.log('triggered');

  const excludePagePaths = ['/contact', '/winkelafspraak', '/wonen-inspiratieboek', '/winkelvoorwaarden', '/interieuradvies', '/andere-vragen', '/cart', '/loov'];
  const currentPath = window.location.pathname;

  // Helper: check of widget recent gesloten is (binnen 15 dagen)
  function isFutyRecentlyClosed() {
    const data = JSON.parse(localStorage.getItem('futyClosedInfo'));
    if (!data || !data.timestamp) return false;

    const now = new Date().getTime();
    // const fifteenDays = 10 * 1000;
    const fifteenDays = 15 * 24 * 60 * 60 * 1000;

    return now - data.timestamp < fifteenDays;
  }

  // Stoppen als pagina is uitgesloten of widget recent gesloten
  if (excludePagePaths.find(a => currentPath.includes(a))) return;
  if (isFutyRecentlyClosed()) return;

  let hasScrolled = false;
  let timerStarted = false;

  console.log('futy enabled');

  // Open widget na scroll + 5 seconden
  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 450 && !hasScrolled) {
      hasScrolled = true;

      if (!timerStarted) {
        timerStarted = true;

        console.log('futy timer started');

        setTimeout(function () {
          if (window.Futy?.widgetVisible === false) {
            console.log('futy ⏱️ Openen na scroll + vertraging');
            window.Futy.EventBus.$emit("widget-open");
          }
        }, 5000);
      }
    }
  });

        function futyToggled(){
          console.log('bij een toggle zetten we altijd futy')
          localStorage.setItem('futyClosedInfo', JSON.stringify({
              timestamp: new Date().getTime()
            }));
        }

  // Gebruik 'widget-toggle' om sluiting te detecteren
  const waitForEventBus = setInterval(() => {
    if (window.Futy && window.Futy.EventBus && typeof window.Futy.EventBus.$on === 'function') {
      clearInterval(waitForEventBus);

      window.Futy.EventBus.$on('widget-toggle', () => {
        futyToggled();
      });
      window.Futy.EventBus.$on('widget-open', () => {
        futyToggled();
      });
      window.Futy.EventBus.$on('widget-closed', () => {
        futyToggled();
      });
    }
  }, 250);
  
      },
      readmore: () => {
    const charLimit = 150;

  $('.auto-readmore').each(function () {
    const $original = $(this);
    const fullHtml = $original.html();
    const temp = $('<div>').html(fullHtml);

    let charCount = 0;
    let cutoffReached = false;

    function getCroppedHtml(node) {
      if (cutoffReached) return '';

      if (node.nodeType === 3) {
        const text = node.nodeValue;
        if (charCount + text.length <= charLimit) {
          charCount += text.length;
          return text;
        } else {
          const visibleText = text.slice(0, charLimit - charCount);
          cutoffReached = true;
          return visibleText + '...';
        }
      } else if (node.nodeType === 1) {
        const tagName = node.nodeName.toLowerCase();
        const attrs = Array.from(node.attributes).map(attr => `${attr.name}="${attr.value}"`).join(' ');
        const open = `<${tagName}${attrs ? ' ' + attrs : ''}>`;
        const close = `</${tagName}>`;

        let inner = '';
        for (let i = 0; i < node.childNodes.length; i++) {
          inner += getCroppedHtml(node.childNodes[i]);
          if (cutoffReached) break;
        }

        return open + inner + close;
      }

      return '';
    }

    const croppedHtml = getCroppedHtml(temp[0]);

    const shortHtml = `
      <div class="readmore-short">
        ${croppedHtml}<span class="readmore-dots"> </span>
        <a href="#" class="readmore-toggle">Lees meer</a>
      </div>
    `;

    const fullHtmlWrapped = `
      <div class="readmore-full" style="display:none;">
        ${fullHtml}
        <a href="#" class="readmore-toggle">Lees minder</a>
      </div>
    `;

    $original.html(shortHtml + fullHtmlWrapped);
  });

  // Toggle between short and full
  $(document).on('click', '.readmore-toggle', function (e) {
    e.preventDefault();
    const $container = $(this).closest('.auto-readmore');
    $container.find('.readmore-short, .readmore-full').toggle();
  });
      },
          productSwitcher: {
              init: () => {
                console.log('productSwitcher inited....')
                  if (!jnApp.vars.variantBundles || jnApp.vars.variantBundles.length == 0) return;

                
  
                  let currentUrl = window.location.href;
                  window.addEventListener('querystringchange', () => {
                      let newUrl = window.location.href;
                      if (currentUrl != newUrl) {
                          currentUrl = newUrl;
                          setTimeout(() => {
                            app.productSwitcher.productDetailPage();
                            app.productSwitcher.productCollections();
                          },750);
                      }
                  })
                
                  document.addEventListener('click', function (e) {
                    let switchProducts = false;
                    
                    if(e.target && (typeof $(e.target).attr('data-t4s-tab-item') !== 'undefined' || typeof $(e.target.offsetParent).attr('data-t4s-tab-item') !== 'undefined')) switchProducts = true;
                      if (switchProducts) {
                          setTimeout(() => {
                            app.productSwitcher.productDetailPage();
                            // app.productSwitcher.productCollections();
                          },250);
                      }
                  });
  
                  app.productSwitcher.productDetailPage();
                  // app.productSwitcher.productCollections();
              },
              productCollections: () => {
                  try {
                      $('.t4s-product-wrapper').each(function (index, $productWrapper) {
                          let switchConfig = false;
                          console.log($($productWrapper))
                          $($productWrapper)
                              .find('.t4s-pr-item-btn')
                              .each(function (index, $productButton) {
                                  let productId = $($productButton).attr('data-id');
                                  console.log('productId', productId)
                                  if (!productId) return;
  
                                  let tempFindMatchingProduct = jnApp.vars.variantBundles.find((variantBundle) => {
                                      let matchingProduct = variantBundle.variants.find((variant) => variant.product_id == productId);
                                      return !!matchingProduct;
                                  });
  
                                  if (tempFindMatchingProduct) {
                                      switchConfig = tempFindMatchingProduct;
                                  }
                              });
  
                          console.log({ switchConfig });
  
                          if (!switchConfig) return;
                          if($($productWrapper).find('.jn-switch-variants').length > 0) return;
  
  
                        console.log($($productWrapper)
                              .find('.t4s-product-info__inner'))
                        
                          $($productWrapper)
                              .find('.t4s-product-info__inner')
                              .append(app.productSwitcher.variantSwitcherHtml({ switchConfig, productId: false }));
                      });
                  } catch (err) {
                      if (err === 'silent') return;
                      console.error(err);
                  }
              },
              productDetailPage: () => {
                  try {
                    console.log(`$('.shopify-section-pr_summary').length`,$('.shopify-section-pr_summary').length)
                      if ($('#shopify-section-pr_summary').length == 0) throw 'silent';
                      if (!jnApp.vars || !jnApp.vars.product || !jnApp.vars.product.data || !jnApp.vars.product.data.id) throw 'silent';
  
                      let switchConfig = jnApp.vars.variantBundles.find((variantBundle) => {
                          let matchingProduct = variantBundle.variants.find((variant) => variant.product_id == jnApp.vars.product.data.id);
                          return !!matchingProduct;
                      });
  
                      console.log('productDetailPage switchConfig', switchConfig);
                  
                      if (!switchConfig) return;
                      if($('#shopify-section-pr_summary').find('.jn-switch-variants').length > 0) return;
  
                      $('#shopify-section-pr_summary').append(`
                          <div>
                              ${
                                  switchConfig.title
                                      ? `
                                  <h4 class="t4s-swatch__title"><span>${switchConfig.title}</span></h4>
                              `
                                      : ``
                              }
                              ${app.productSwitcher.variantSwitcherHtml({ switchConfig, productId: jnApp.vars.product.data.id })}
                          </div>
                      `);
                  } catch (err) {
                      if (err === 'silent') return;
                      console.error(err);
                  }
              },
              variantSwitcherHtml: ({ switchConfig, productId }) => {
                  return `
                      <div class="jn-switch-variants">
                          ${switchConfig.variants
                              .map((variant) => {
                                  return `
                                  <div class="jn-switch-variant">
                                      <a href="/variants/${variant.variant_id}" class="jn-switch-variant-link ${
                                      productId == variant.product_id ? `jn-switch-variant-link-active` : ``
                                  }" style="background-color:${variant.color}"></a>
                                  </div>
                              `;
                              })
                              .join('')}
                      </div> 
                  `;
              },
          },
        
        goBack: () => {
            $('.goback').on('click', function(e){
              e.preventDefault()
              console.log('hi')
              if (document && document.referrer && typeof document.referrer === 'string' && document.referrer.includes('kas20.nl')) {
                // history.back();
                window.location.href = document.referrer
              } else {
                window.location.href = "https://kas20.nl";
            
              }
            })
        },
        findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            var items = location.search.substr(1).split('&');
            for (var index = 0; index < items.length; index++) {
                tmp = items[index].split('=');
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            }
            return result;
        },
        faq: {
            init: () => {
                if ($('.jn-faq-page').length == 0) return;
                app.faq.render();
                app.faq.listen();
            },
            render: () => {
                let urlGroups = {};

                $('.jn-faq-page-menu a').each(function (index, $a) {
                    if (!$($a).attr('href') || $($a).attr('href').startsWith('#')) return;

                    let urlGroup = 'none';

                    if ($($a).attr('data-group')) urlGroup = $($a).attr('data-group');

                    if (!urlGroups[urlGroup])
                        urlGroups[urlGroup] = {
                            name: urlGroup,
                            urls: [],
                        };

                    let active = false;

                    let url = $($a).attr('href');

                    if (window.location.pathname.endsWith(url)) {
                        active = true;
                        $($a).addClass('active');
                    }

                    urlGroups[urlGroup].urls.push({
                        name: $($a).text(),
                        url: url,
                        active: active,
                    });

                    console.log($($a));
                });

                $('.jn-faq-page').prepend(`
            <div class="faq-select-navigation">
              <label>Kies een vraag</label>
              <select class="faq-select-navigation-select">
                  ${Object.entries(urlGroups)
                      .map((entry) => {
                          const [key, value] = entry;
                          return `
                      <optgroup label="${key}">
                        ${value.urls
                            .map((item) => {
                                return `
                            <option ${item.active ? 'selected' : ''} value="${item.url}">${item.name}</option>
                          `;
                            })
                            .join('')}
                      </optgroup>
                    `;
                      })
                      .join('')}
              </select>
            </div>
          `);
            },
            listen: () => {
                $('.faq-select-navigation-select').on('change', function (e) {
                    e.preventDefault();
                    window.location.href = `${$(this).val()}#faq_section`;
                });
            },
        },
        showLoading: (options) => {
            let html = `<h2>Schroeven vastdraaien...</h2>`;

            if (options && options.html) html = options.html;

            Swal.fire({
                html: html,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        },
        removeProductPageReviews: () => {
            if (!window.location.pathname.includes('/products/')) return;

            if ($('.hc-product-summary__reviews .hc-icon--star-o').length == 5) $('.hc-product-summary__reviews').hide();
        },
        configuratorModal: {
            init: () => {
                // 'event': 'configurator_open', Configurator is opened
                // 'event': 'configurator_add_to_cart', Added configurator product to cart
                // 'event': 'configurator_product_presets_modal' Opened the pre modal (choose bank or table)
                // 'event': 'configurator_save_and_close', Saved and closed modal
                // 'event': 'configurator_recover', Recovered a url
                // 'event': 'configurator_force_close', Closed a modal without saving

                app.configuratorModal.listen();

                if (app.findGetParameter('open-configurator') == 'tafel') app.configuratorModal.open({});
                if (app.findGetParameter('open-configurator') == 'presets') app.configuratorModal.productPresetsModal();
            },
            currentPageChangedCount: 0,
            productPresetsModal: () => {
                dataLayer.push({
                    event: 'configurator_product_presets_modal',
                });

                Swal.fire({
                    customClass: `jn-swal-configuration-options-swal`,
                    html: `
                <div class="jn-swal-configuration-options-container">
                  <h2>Jouw droommeubel start hier...</h2>
                  <p>Kom naar een van onze showrooms echt te voelen en ontdekken hoe onze vakmensen jouw product tot leven brengen.</p>
                  <div class="jn-swal-configuration-options">
                    <a href="#tafel_1" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Massief4cmNaturelDeensFreya_4_1080x_3a4cc799-24d4-4536-8431-64fc9fc96fca.webp?v=1741343249');">Eettafel</a>
                    <a href="https://kas20.nl/collections/tuintafels-1/products/keramiek-tuintafel-cuarzo-reno-deens-ovaal-matrix-dun-beige?variantCode=TUINTAFEL%3DTuintafel-a1%26Materiaal-a7%26Tafelkleuren-p27%26Bladvorm-a4%26Bladdikte-b15%26Lengte-a1%26Breedte-a1%26RondAfmeting-%26Hoogte-a2%26Onderstellen-b2%26Kleuronderstel-c9%26HiddenOptionSKUcodeforthinckness-a1%26Melding-%26SPECIAL-a1%26Meldingonderstel-%26Meldingkleuronderstel-" style="background-image:url('https://kas20.nl/cdn/shop/files/KEM1014080DOR097MDBH76-4.jpg?v=1745912812');">Tuintafel</a>
                    <!--<a href="https://kas20.nl/pages/banken-overzicht" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2023-12-22_at_18.03.52.png?v=1703264666');">Bank</a>-->
                    <a href="https://kas20.nl/pages/configureer-bank" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/1_1080x_015a3468-8a01-41f9-b87f-f9c1e58378aa.webp?v=1741343249');">Bank</a>
                    <a href="https://kas20.nl/collections/salontafels-1/products/keramiek-eiken-duo-salontafel-rond-maan-onderstel?variantCode=SALONTAFEL%3DAantalsalontafels-a2%26Materiaal-%26Tafelkleuren-%26Bladvorm-%26Randafwerking-%26Randkleur-%26Bladdikte-%26Lengte-%26Breedte-%26RondAfmeting11-%26Hoogte-%26Onderstellen-b25%26Kleuronderstel-%26HiddenOptionSKUcodeforthinckness-a1%26Melding-%26HiddenOptionSKUcodeforthinckness1-a1%26Tafelkleuren1-o6%26Bladvorm1-a11%26RondAfmeting-a3%26Randafwerking1-b15%26Randkleur1-a7%26Bladdikte1-b16%26Tafelkleuren11-b5%26Bladvorm11-a1%26RondAfmeting1-a1%26Randafwerking11-b9%26Randkleur11-a5%26Bladdikte11-b9%26FenixRandkleurWaarschuwing-%26FenixRandkleurWaarschuwing1-%26FenixRandkleurWaarschuwing11-%26KleuronderstelMassief1-b5%26SalonExtra-a2" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/20-113_1080x_ee82c0ea-5c73-46a2-a286-441e80852b3f.webp?v=1741343249');">Salontafel</a>
                    <!--<a href="https://kas20.nl/pages/configureer-bank" style="background-image:url('https://cdn.shopify.com/s/files/1/0269/4840/3234/files/067904b5-60e3-4ca8-8d03-c34ac94c7bcc_x425_eecb3c1c-e995-444b-807d-be56a3263796.png?v=1717752702');">Bank</a>-->
                  </div>
                </div>
              `,
                    background: 'transparent',
                    showCancelButton: true,
                    showConfirmButton: false,
                    width: 700,
                    confirmButtonColor: '#000',
                    cancelButtonText: 'Sluiten',
                });
            },
            open: (options) => {

              app.configuratorModal.productPresetsModal();
              return;

              
              
                app.configuratorModal.currentPageChangedCount = 0;

                // let configuratorUrl = options && options.url ? options.url : `https://kas20.frontend-accept.3dimerce.com/nl-nl/permalink/dw9CTf`;
              
                // let configuratorUrl = options && options.url ? options.url : `https://kas20.frontend-accept.3dimerce.com/nl-nl/permalink/tFOrPe`;
                // let configuratorUrl = options && options.url ? options.url : `https://kas20.frontend.3dimerce.com/nl-nl/permalink/tFOrPe`;
              let configuratorUrl = options && options.url ? options.url : `https://kas20.frontend.3dimerce.com/nl-nl/permalink/EoXMCK`;

              
              
                let defaultButton = options && options.url ? false : true;

                let iframeId = 'swal__iframe_configurator';
                let recoverUrl =
                    localStorage.getItem('jn_configurator_recover_url') && typeof localStorage.getItem('jn_configurator_recover_url') !== 'undefined'
                        ? localStorage.getItem('jn_configurator_recover_url')
                        : false;

                // <i class="las la-undo"></i>

                dataLayer.push({
                    url: configuratorUrl,
                    event: 'configurator_open',
                    default_button: defaultButton,
                });

                Swal.fire({
                    // customClass: 'swal-preview-configurator',
                    customClass: {
                        container: 'swal-preview-configurator',
                    },
                    html: `
                <div class="jn-swal-custom-close-dialog">
                  <button class="jn-swal-custom-close-dialog-show">&times;</button>
                  <div class="jn-swal-custom-close-dialog-options">
                    <button class="jn-swal-custom-close-dialog-close jn-swal-configuration-action"><i class="las la-trash"></i><span>Sluiten</span></button>
                    <button class="jn-swal-custom-close-dialog-save-and-close jn-swal-configuration-action"><i class="las la-save"></i><span>Opslaan en sluiten</span></button>
                  </div>
                  ${recoverUrl ? `<button class="jn-swal-custom-close-dialog-recover jn-swal-configuration-action"><i class="las la-cloud-download-alt"></i><span>Herstel</span></button>` : ``}
                  
                </div>
                <div class="jn-swal-dialog-backdrop"></div>
                <iframe id="${iframeId}" src="${configuratorUrl}" data-hj-allow-iframe style="width:100%;border-width:0px;margin-bottom:2px;height:85vh;user-select: none;" class="iframe-configurator"></iframe>
              `,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    showCloseButton: false,
                    width: 1300,
                    showConfirmButton: false,
                    showCancelButton: false,
                    // onOpen: (options) => {
                    //   const iframe = $(`#${iframeId}`)[0];
                    //   console.log(iframe);

                    //   setTimeout(function () {
                    //     if (iframe.contentWindow) iframe.contentWindow.postMessage(JSON.stringify(buttonData), '*');
                    //   }, 1000);

                    //   console.log('im open!!!');
                    // },
                });
            },
            listen: () => {
                let allowedSources = ['https://kas20.frontend-accept.3dimerce.com', 'https://kas20.frontend.3dimerce.com', 'https://configurator.kas20.nl'];
                window.addEventListener(
                    'message',
                    async (event) => {
                        try {
                            //   if (event.origin !== "http://example.org:8080") return;

                            let allowedSource = allowedSources.find((a) => event.origin.includes(a));

                            if (!allowedSource) return;

                            console.log('event from child', event, event.origin);

                            if (!event) return;

                            let eventData = event.data;

                            if (!eventData) return;
                            if (typeof eventData !== 'string') return;

                            if (!eventData.startsWith('[JN_IFRAME]')) return;

                            eventData = eventData.replace('[JN_IFRAME]', '');

                            try {
                                eventData = JSON.parse(eventData);
                            } catch (err) {
                                console.error(err);
                            }

                            console.log(eventData);

                            if (eventData.type == 'add_to_cart') {
                                console.log(eventData.data.addToCart.data);

                                app.showLoading({
                                    html: `
                        <h2>Toevoegen...</h2>
                      `,
                                });

                                dataLayer.push({
                                    event: 'configurator_add_to_cart',
                                });

                                window.location.href = eventData.data.addToCart.data.addToCartUrl;
                                return;
                            }

                            if (eventData.type == 'get_data') {
                                // console.log('get_data -> ',eventData)
                                localStorage.setItem('jn_configurator_recover_url', eventData.data.configuratorUrl);
                                Swal.close();
                            }

                            if (eventData.type == 'page_changed_count') {
                                app.configuratorModal.currentPageChangedCount = eventData.data.pageChangedCount;
                            }

                            if (eventData.type == 'maintenance') {
                                Swal.close();
                                Swal.fire({
                                    width: 700,
                                    confirmButtonColor: 'var(--primary)',
                                    showCancelButton: true,
                                    cancelButtonText: 'Sluiten',
                                    html: `
                        <h2>Tijdelijk in onderhoud</h2>
                        <p>Onze banken configurator is tijdelijk in onderhoud! Kijk tot die tijd gerust even rond op de banken overzicht pagina, of kom langs in een van onze showrooms!</p>
                      `,
                                    reverseButtons: true,
                                    confirmButtonText: 'Alle banken',
                                }).then((result) => {
                                    if (result.isConfirmed) window.location.href = '/collections/alle-banken';
                                });
                            }
                        } catch (err) {
                            console.error(err);
                            Swal.fire({
                                html: `<h2>Er is iets mis gegaan</h2>`,
                                showCancelButton: true,
                                showConfirmButton: false,
                            });
                            return;
                        }
                    },
                    false
                );

              $('a.jn-shipping-brand-link').on('click', function(e){
                
                if($('.single_add_preset_button').length == 0) return;
                if(
                  !$(this).attr('href').includes('configureer-eettafel')
                  && !$(this).attr('href').includes('configureer-bank')
                ) return;
                
                e.preventDefault();

                $('.single_add_preset_button')[0].click()
                
                
              })

              

                $('body').on(
                    'click',
                    '.jn-open-configurator,a[href*="#tafel_1"],a[href="https://kas20.nl/apps/configurator?catalogue=6988131467298&currency=EUR&locale=nl"],a[href="https://kas20.nl/apps/configurator?catalogue=8068406968595&currency=EUR&locale=nl"]',
                    function (e) {
                        e.preventDefault();

                        if($('.mask-overlay').length > 0) $('.mask-overlay').trigger('click');

                        // app.configuratorModal.open({});

                      app.showLoading();
                      window.location.href = 'https://kas20.nl/pages/configureer-eettafel';
                    }
                );
              
                $('body').on(
                    'click',
                    'a[href*="/pages/banken-overzicht"]',
                    function (e) {
                        e.preventDefault();


                        // app.configuratorModal.open({});

                      app.showLoading();
                      window.location.href = 'https://kas20.nl/pages/configureer-bank';
                    }
                );

                $('body').on('click', 'a[href="#emma"],a[href="#micha"],a[href="#sep"],a[href="#rowan"],a[href="#tetris"],a[href="#levi"],a[href="#moos"],a[href="#sara"]', function (e) {
                    e.preventDefault();
                    let toUrl = $(this).attr('href');
                    toUrl = toUrl.replace('#', '');

                    if($('.mask-overlay').length > 0) $('.mask-overlay').trigger('click');
                  
                    app.configuratorModal.open({
                      // url: `https://kas20.frontend-accept.3dimerce.com/nl-nl/${toUrl}`
                      url: `https://kas20.frontend.3dimerce.com/nl-nl/${toUrl}`
                      
                    });

                    // Swal.fire({
                    //     width: 700,
                    //     confirmButtonColor: 'var(--primary)',
                    //     showCancelButton: true,
                    //     cancelButtonText: 'Sluiten',
                    //     html: `
                    //       <h2>Tijdelijk in onderhoud</h2>
                    //       <p>Onze banken configurator is tijdelijk in onderhoud! Kijk tot die tijd gerust even rond op de banken overzicht pagina, of kom langs in een van onze showrooms!</p>
                    //     `,
                    //     reverseButtons: true,
                    //     confirmButtonText: 'Alle banken',
                    // }).then((result) => {
                    //     if (result.isConfirmed) window.location.href = '/collections/alle-banken';
                    // });
                });

                $('body').on('click', 'a[href*="#open_configuration"]', function (e) {
                    e.preventDefault();
                  if($('.single_add_preset_button').length > 0 && $(this).hasClass('visit-showroom-search')){
                    $('.single_add_preset_button')[0].click()
                    return;
                  }

                    
                    if($('.mask-overlay').length > 0) $('.mask-overlay').trigger('click');
                    app.configuratorModal.productPresetsModal();
                });

                $('body').on('click', '.jn-swal-custom-close-dialog-save-and-close', function (e) {
                    e.preventDefault();

                    dataLayer.push({
                        event: 'configurator_save_and_close',
                    });

                    let iframe = $('#swal__iframe_configurator')[0];
                    console.log(iframe.contentWindow);
                    if (iframe.contentWindow)
                        iframe.contentWindow.postMessage(
                            `[JN_IFRAME]${JSON.stringify({
                                type: 'get_data',
                                data: {},
                            })}`,
                            '*'
                        );
                });

                $('body').on('click', '.jn-swal-custom-close-dialog-recover', function (e) {
                    e.preventDefault();

                    dataLayer.push({
                        event: 'configurator_recover',
                    });

                    app.configuratorModal.open({
                        url: localStorage.getItem('jn_configurator_recover_url'),
                    });
                });

                $('body').on('click', '.jn-swal-custom-close-dialog-close', function (e) {
                    e.preventDefault();
                    Swal.close();

                    dataLayer.push({
                        event: 'configurator_force_close',
                    });
                });

                $('body').on('click', '.jn-swal-dialog-backdrop', function (e) {
                    e.preventDefault();
                    $('.jn-swal-custom-close-dialog-show').trigger('click');
                });

              $('.trigger_single_add_preset_button').on('click', function(e){
                e.preventDefault()
                

                const el = document.querySelector('.mmq-embed');
                if(el){
                  el.show()
                } else {
                  $('.single_add_preset_button').trigger('click')  
                }
              })

                $('body').on('click', '.jn-swal-custom-close-dialog-show', function (e) {
                    e.preventDefault();
                    console.log(app.configuratorModal.currentPageChangedCount);
                    if (app.configuratorModal.currentPageChangedCount < 3) {
                        Swal.close();
                    } else {
                        $(this).parent().toggleClass('dialog-open');
                    }
                });

                $('.single_add_preset_button:not(.mmq-button),.simple-preset-url').on('click', function (e) {
                    e.preventDefault();

                    app.configuratorModal.open({
                        url: $(this).attr('href'),
                    });
                });

              $('.mmq-button').on('click', function(e){
                e.preventDefault();
              })
            },
        },
    };

    app.init();

    // $('body').on('click', '.jn-stores', function (e) {
    //     // jnStores
    //     let storeIds = $(this).attr('data-stores');
    //     if (storeIds) {
    //         storeIds = storeIds.split(',');
    //     } else {
    //         storeIds = ['de-kwakel-01', 'helmond-01', 'almere-01'];
    //     }

    //     let filterStores = jnStores;

    //     if (storeIds && storeIds.length > 0) {
    //         filterStores = jnStores.filter((a) => storeIds.includes(a.id));
    //     }

    //     console.log(filterStores);

    //     let storesHtml = ``;

    //     filterStores.forEach((store) => {
    //         storesHtml += `
    //     <div class="jn-store">
    //       <div class="jn-store-image" style="background-image:url('${store.store_img}');"></div>
    //       <div class="jn-store-content">
    //         <h2>${store.name}</h2>
    //         <div>${store.description}</div>
    //         <div class="jn-store-columns">
    //           <div>
    //             <h5>Openingstijden</h5>
    //             <p>${store.times}</p>
    //           </div>
    //           <div>
    //             <h5>Adres</h5>
    //             <p>${store.address}</p>
    //             <a class="jn-btn jn-btn-primary" href="${store.store_url}">Bezoek showroom &rarr;</a>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   `;
    //     });

    //     e.preventDefault();
    //     Swal.fire({
    //         width: 700,
    //         confirmButtonColor: 'var(--primary)',
    //         showCancelButton: true,
    //         cancelButtonText: 'Sluiten',
    //         html: `
    //     <div class="jn-stores-container">
    //       ${storesHtml}
    //     </div>
    //   `,
    //         reverseButtons: true,
    //         confirmButtonText: 'Bekijk alle',
    //     }).then((result) => {
    //         if (result.isConfirmed) window.location.href = '/pages/showroom-bezoeken';
    //     });
    // });
    /**
     * Variant selection changed
     */
    $(document).on('variant:change', function (evt, variant) {
        //console.log( variant );
    });

    if ($('body').hasClass('template-collection') && false) {
        // console.log("colleciton temaplte!");
        var scrollCartTop = $('.id_collection_page').offset().top - $('#ntheader').height() - 0;
        var style = document.createElement('style');
        style.innerHTML = `
            @media screen and (min-width: 1025px){
                .cat_shop_wrap {
                    margin-top: -${scrollCartTop}px;
                }
            }
         `;
        // document.head.appendChild(style);
    }

    console.log('SECONDARY_THEME', SECONDARY_THEME);

    $('div.branding').parent().append(`
    <div class="select customized-select theme-select">
      <div class="select-field">
        <input type="radio" name="select" class="theme-select-input" id="option-1" value="value-1" ${!SECONDARY_THEME ? 'checked' : ''} />
        <label for="select-focus">
          <span class="select-theme-title">Kas20 Original <svg class="theme-select-arrow" height="1em" style="" viewBox="0 0 2240.0 2240.0" width="1em" xmlns="http://www.w3.org/2000/svg"><g transform=""><path d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"></path><rect class="hc-icon__transparent-background"></rect></g></svg></span>
          <span class="select-theme-subtitle">Oneindig veel keuze</span>
        </label>

        <input type="radio" name="select" class="theme-select-input" id="option-2" value="value-2" ${SECONDARY_THEME ? 'checked' : ''} />
        <label for="select-focus">
          <span class="select-theme-title">Kas20 Snel Geleverd <svg class="theme-select-arrow" height="1em" style="" viewBox="0 0 2240.0 2240.0" width="1em" xmlns="http://www.w3.org/2000/svg"><g transform=""><path d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"></path><rect class="hc-icon__transparent-background"></rect></g></svg></span>
          <span class="select-theme-subtitle">Uit voorraad geleverd</span>
        </label>

        <label class="select-placeholder" for="select-focus"
          >Kies een thema</label
        >
      </div>

      <input
        id="select-focus"
        readonly
        type="text"
        class="select-options-focus"
      />

      <div class="select-options">
        <label for="option-1">Kas20 Original</label>
        <label for="option-2">Kas20 Snel Geleverd</label>
      </div>
    </div>
  `);

    var lockThemeRedirect = false;

    function themeRedirect() {
        if (lockThemeRedirect) return;
        lockThemeRedirect = true;
        var theme1 = $('#option-1').is(':checked');
        var theme2 = $('#option-2').is(':checked');

        if (theme1) window.location.href = '/';
        if (theme2) window.location.href = '/collections/snel-geleverd';
    }

    $('#option-1').on('change', function () {
        themeRedirect();
    });
    $('#option-2').on('change', function () {
        themeRedirect();
    });

    setTimeout(function () {
        if ($('#preview-bar-iframe').length > 0) {
            $('body').addClass('shopify-admin');
        }
    }, 500);

    jn_fab_items = jn_fab_items.sort(function (a, b) {
        if (a.order > b.order) return -1;
        if (a.order < b.order) return 1;
        return 0;
    });

  if(false){
  $('body').append(`
      <div class="jn-fab-container">
        <button class="jn-fab-button jn-fab-whatsapp-overwrite">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16.074" viewBox="0 0 16 16.074">   <g id="Group_63773" data-name="Group 63773" transform="translate(-426.525 -322.416)">     <path id="Path_12957" d="M537.461 442.133a2.6 2.6 0 0 0 .792.121 3.292 3.292 0 0 0 .491-.039 2.106 2.106 0 0 0 1.41-1 1.658 1.658 0 0 0 .1-1.026.694.694 0 0 0-.316-.22l-.105-.052c-.138-.069-1.153-.57-1.349-.642a.417.417 0 0 0-.573.141c-.119.179-.469.594-.611.756-.063.072-.114.11-.289.022-.035-.017-.079-.036-.135-.061a4.916 4.916 0 0 1-1.414-.894 5.756 5.756 0 0 1-1.066-1.328c-.069-.119-.031-.164.068-.263.063-.062.133-.148.2-.231l.1-.118a1.215 1.215 0 0 0 .184-.294l.027-.055a.471.471 0 0 0-.016-.443c-.031-.062-.227-.539-.384-.922l-.216-.524c-.156-.375-.341-.406-.5-.4h-.038c-.125-.006-.269-.007-.381-.007a.826.826 0 0 0-.6.281l-.037.04a2.29 2.29 0 0 0-.677 1.668 3.843 3.843 0 0 0 .821 2.091l.032.045a8.577 8.577 0 0 0 3.356 2.945 11.314 11.314 0 0 0 1.126.409z" class="cls-1" data-name="Path 12957" transform="translate(-101.636 -108.015)"></path>     <path id="Path_12958" d="M440.2 324.745a7.945 7.945 0 0 0-12.526 9.544l-1.15 4.2 4.3-1.127a7.946 7.946 0 0 0 9.379-12.617zm-5.622 12.015a6.386 6.386 0 0 1-3.255-.891l-.278-.165-2.32.609.619-2.261-.181-.288a6.4 6.4 0 1 1 5.418 3v.113z" class="cls-1" data-name="Path 12958"></path>   </g> </svg>
        </button>
      </div>
    `);
  
    $('.jn-fab-whatsapp-overwrite').on('click', function(e){
      e.preventDefault()
      $('.whatsappbutton').trigger('click');
    })
  }
  

  
    if (jn_fab_items.length > 0 && false) {
        $('body').append(`
      <div class="jn-fab-container">
        <button class="jn-fab-button">
          
        </button>
        <div class="jn-fab-items">
          ${jn_fab_items
              .map(
                  (item, index) => `
            <div class="jn-fab-item ${item.button_style}">
              <div class="jn-fab-item-quickview" data-index="${index}">${item.icon ? `${item.icon}&nbsp;` : ''}${item.name}</div>
              <div class="jn-fab-item-popup">
                <div class="jn-fab-item-popup-inner">
                  ${item.content}
                  ${item.url && !item.url_title ? `<a href="${item.url}" class="btn-theme-solid">Lees meer</a>` : ``}
                  ${item.url && item.url_title ? `<a href="${item.url}" class="btn-theme-solid">${item.url_title}</a>` : ``}
                </div>
              </div>
            </div>
          `
              )
              .join('')}
        </div>
      </div>
    `);

        if (!sessionStorage.getItem('jn_fab_clicked')) {
            $('.jn-fab-button').addClass('pulse');
        }

        let extraItems = $('.jn-fab-item').length > 3;
        let userInteracted = true;
        if (typeof sessionStorage.getItem('jn_fab_clicked') === 'undefined' || !sessionStorage.getItem('jn_fab_clicked')) userInteracted = false;

        console.log({
            userInteracted,
            extraItems,
        });

        function toggleFab(view, icon) {
            if (!userInteracted && !extraItems && !view) {
                view = 'show';
            }

            userInteracted = true;
            sessionStorage.setItem('jn_fab_clicked', '1');

            if (!view) view = $('.jn-fab-button').attr('data-view');

            $('.jn-fab-item-popup').hide();

            // if current state is show
            if (view == 'show') {
                $('.jn-fab-button').attr('data-view', 'hide');
                showQuickView('hide');
            }
            // if unset or is current state is hide
            if (!view || view == 'hide') {
                $('.jn-fab-button').attr('data-view', 'show');
                showQuickView('show');
            }
        }

        function showQuickView(view) {
            if (view == 'show') {
                $('.jn-fab-item-quickview').show();
            }
            if (view == 'hide') {
                $('.jn-fab-item-quickview').hide();
            }
        }

        // user has already interacted, hide
        if (userInteracted || window.matchMedia('(max-width: 600px)').matches) {
            toggleFab('show');
        }

        function showPopup() {}

        $('.jn-fab-button').on('click', function (e) {
            e.preventDefault();
            toggleFab();
        });

        $('.jn-fab-item-quickview').on('click', function (e) {
            e.preventDefault();

            let index = Number($(this).attr('data-index'));
            let item = jn_fab_items[index];

            if (item.hasCallback) {
                item.callback(e, {
                    toggleFab,
                });
                return;
            }

            toggleFab('show');

            $(this).parent().find('.jn-fab-item-popup').show();
        });
    }

    function randomIntFromInterval(min, max) {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
        $('.jn-top-bar-items').each(function (index, $container) {
            $($container).find('.jn-top-bar-item').hide();
            $('.jn-top-bar-items').removeClass('hide');

            let itemMaxIndex = $($container).find('.jn-top-bar-item').length - 1;
            let itemIndex = randomIntFromInterval(0, itemMaxIndex);
            let duration = 600;

            function displayNext() {
                if (itemIndex == itemMaxIndex) itemIndex = 0;

                $($container)
                    .find('.jn-top-bar-item')
                    .fadeOut({
                        duration: duration,
                        complete: function () {
                            setTimeout(function () {
                                $($($container).find('.jn-top-bar-item')[itemIndex]).fadeIn();
                            }, duration + 10);
                        },
                    });

                itemIndex = itemIndex + 1;
            }

            $($container).find('.jn-top-bar-item').hide();
            setInterval(displayNext, 5000);
            displayNext();
        });
    } else {
        $('.jn-top-bar-items').removeClass('hide');
        $('.jn-top-bar-items').fadeIn();
    }

    // $('a[href="#open_sidemenu"]').on('click', function () {
    //     openSidemenu();
    // });

    setTimeout(function () {
        $('ul.swatch-view').css({ transform: 'translateX(0px)' });
    }, 1500);

    setTimeout(function () {
        $('a div, a span').each(function (index, a) {
            let html = $(a).html();
            if (!html.includes('-&gt;')) return;

            html = html.replaceAll('--&gt;', '<span class="inter">--></span>');
            html = html.replaceAll('-&gt;', '<span class="inter">-></span>');

            $(a).html(html);
        });
    }, 250);

      $('body').on('click', 'a[href^="#scroll_to_"]',function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top - 250
        }, 1000);
    });

    //   $('a[href="tel:+31%20(0)20-2101966"]').html(`0613424839`)
    //   $('a[href="tel:+31%20(0)20-2101966"]').attr(`href`,`tel:0613424839`)

    //   $('a[href="tel:020-2101966"]').html(`0613424839`)
    //   $('a[href="tel:020-2101966"]').attr(`href`,`tel:0613424839`)

    //   setInterval(function(){
    //     $('a[href="tel:020-2101966"]').html(`0613424839`)
    //     $('a[href="tel:020-2101966"]').attr(`href`,`tel:0613424839`)

    //     $('a[href="tel:0202101966"]').html(`0613424839`)
    //     $('a[href="tel:0202101966"]').attr(`href`,`tel:0613424839`)

    //   },1000)

    if (window.location.href.includes('black-friday')) {
        // Swal.fire({
        //   html: `
        //     <br>
        //     <h1>Let op!</h1>
        //     <p>Black Friday start 20 november 00:00.<p>
        //   `,
        //   confirmButtonText: 'Sluiten'
        // })

        $('.container_des, .id_collection_page > .container_cat').append(`
  <div style="margin-top: 50px;">
  <h3>Aanvullende voorwaarden:</h3>
  <p>Bekijk alle aanvullende voorwaarden van deze speciale aanbieding <a href="/pages/speciale-aanbieding">hier</a>.</p>
</div>
  `);
    }

    $('a[href]').each(function (index, $el) {
        if ($($el).attr('href') && ($($el).attr('href').startsWith('/') || $($el).attr('href').startsWith('https://kas20.nl'))) {
            $($el).attr('target', '');
        }
    });

    let discountReplace = [
        //   {
        //   title: 'banken',
        //   urls: ['/collections/speciale-aanbieding-banken'],
        //   discount: 5
        // },{
        //   title: 'stoelen',
        //   urls: ['/collections/speciale-aanbieding-stoelen'],
        //   discount: 10
        // },{
        //   title: 'beton tafel',
        //   urls: ['/collections/speciale-aanbieding-betonlook'],
        //   discount: 10
        // },{
        //   title: 'patronen eettafels',
        //   urls: ['/collections/speciale-aanbieding-patronen'],
        //   discount: 10
        // }
        //                        ,{
        //   title: 'jesper home',
        //   urls: ['/collections/speciale-aanbieding-jesper'],
        //   discount: 10
        // }
      // {
      //     title: 'jesper home',
      //     urls: ['/collections/jesper-home'],
      //     discount: 15
      //   }
    ];


    let stopIfDiscountReplaced = $('body').hasClass('template-product')
    let discountReplaced = false;

    function replaceFunction(percentage) {
        $('.spf-product-card__price.money:not(.converted),#price_ppr:not(.converted),.sticky_atc_price:not(.converted)').each(function (index, $el) {
            let numberString = $($el).html();

            let storeData = $($el).data();

            if (storeData.numberString) {
                if (numberString != storeData.numberString && $($el).find('.jn-money-old').length > 0) {
                    numberString = $($el).find('.jn-money-old').html();
                } else {
                    numberString = storeData.numberString;
                }
            } else {
                $($el).data({
                    numberString: numberString,
                });
            }

            // let numberArray = numberString.split(',')
            // let numberMatch = numberArray[0].replace(/[^0-9]/g,"");
            // let numberTotal = Number(numberMatch)

            let numberMatch = numberString.replace(/[^0-9]/g, '');
            let numberTotal = Number(numberMatch) / 100;

            // $($el).addClass('converted')
            if (!$($el).attr('id') == 'price_ppr') {
                $($el).addClass('converted');
            }

            // if($($el).find('.jn-money-old')){
            //   numberTotal = Number($($el).find('.jn-money-old').attr('data-price'))
            // }

            // let discountPrice = Number(numberTotal / 100 * (100 - percentage)).toFixed(2);
            let discountPrice = Number((numberTotal / 100) * (100 - percentage));
            // console.log(percentage)
            // let discountPrice = Number(numberTotal / 100 * (100 - 10));
            let discountEur = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', roundingMode: 'ceil' }).format(discountPrice);

            $($el).html(`
        <del class="jn-money-old" data-price="${numberTotal}">${numberString}</del>
        <ins class="jn-money-new">${discountEur.replace(/\s/g, '')}</ins>
      `);
          discountReplaced = true;

          $('script[type="application/ld+json"]').each(function(index, $script){
            
            try{
              let ldJson = JSON.parse($($script)[0].firstChild.nodeValue)
              if(ldJson['@type'] == 'Product' && ldJson.offers){
                ldJson.offers.price = Number(discountPrice).toFixed(2)
                ldJson.offers.lowPrice = Number(discountPrice).toFixed(2)
                ldJson.offers.highPrice = Number(numberTotal).toFixed(2)

                $($script).html(JSON.stringify(ldJson,null,2))
              }
            }catch(err){
              // 
            }
          })

//           const script = document.getElementById("myjsonid");
// const obj = JSON.parse(script.firstChild.nodeValue);
// obj.image = "***THIS IS THE UPDATE***";
// script.firstChild.nodeValue = JSON.stringify(obj);
// console.log(script.firstChild.nodeValue);
        });
    }

    discountReplace.forEach(function (discount) {
        if (!window.location.pathname) return;
        let matchUrl = discount.urls.find((url) => window.location.pathname.includes(url));
        if (!matchUrl) return;

        console.log({ matchUrl, discount });

        let replaceInterval;

        function discountTimer() {
            replaceFunction(discount.discount);
            if(stopIfDiscountReplaced && discountReplaced && replaceInterval) clearTimeout(replaceInterval);
        }

        replaceInterval = setInterval(discountTimer, 1000);
    });

    // spf-product-card__price money

    // if(moment().isAfter('2023-11-27 00:00')){
    // if(window.location.pathname.includes('black-friday')){
    // $('.slt4_btn,.f_heading,h1,a.lh__1,.lh__1,p,.jn-fab-item-quickview,h2,h3,h4,h5,h6').each(function(index, $el){
    //     let text = $($el).text()
    //     if(!text) return;
    //     if(text.includes('Black Friday')){
    //         let _html = $($el).html();
    //         if($($el).hasClass('lh__1')){
    //             $($el).css({'padding-left':'5px'})
    //         }
    //         $($el).html(_html.replace('Black Friday', 'Cyber Monday'));
    //     }
    // })
    // }
    // }

    // if(moment().isBefore('2023-12-30 00:00')){
    //   $('head').append(`
    //     <style>
    //       .la-shopping-cart:before {
    //         content: "\\f07a";
    //         content: "\\f7cc" !important;
    //       }
    //     </style>
    //   `)
    // }

    // $('.cart-json').each(function(index, $item){
    //   console.log($($item).html());
    // })
    // JSON.parse($($('.cart-json')[0]).html())

    function convertFormToJSON(form) {
        return $(form)
            .serializeArray()
            .reduce(function (json, { name, value }) {
                json[name] = value;
                return json;
            }, {});
    }

    if($('.hc-widget').length > 0){
  
      var numChecks = 0;
      function checkHcReview()
      {
        if($($('.hc-widget')[0]).find('.hc-icon--star').length > 0){
          $('.hc-widget').addClass('hc-show')
          return;
        }
          if($($('.hc-widget')[0]).find('.hc-icon--star-o').length > 2){
            return;
          }
        
          numChecks++;
          if (numChecks < 20) setTimeout(checkHcReview, 500);
      }
      
      setTimeout(checkHcReview, 500);
    }

    $('body').on('submit', '.spf-product__form', async function (e) {
        // $(this).submit()

        e.preventDefault();

        if ($('.jn-loading').length > 0) return;

        let $submitForm = $(this);
        $($submitForm).addClass('jn-loading');

        // Swal.fire({
        //    html: `<h4>Toevoegen...</h4>`,
        //    didOpen: () => {
        //      Swal.showLoading();
        //    },
        //    allowEnterKey: false,
        //    allowOutsideClick: false,
        //    allowEscapeKey: false,
        //  });

        try {
            let requestAdd = await fetch(`${$($submitForm).attr('action')}.js`, {
                method: 'POST',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(convertFormToJSON($submitForm)),
            });

          //   let requestCart = await fetch(`/cart.js`, {
          //       method: 'GET',
          //       cache: 'no-cache',
          //       headers: {
          //           'Content-Type': 'application/json',
          //       },
          //   });

          // let cart = await requestCart.json()
          // try{
          //   // console.log('new cart...',{data})
          //   jnApp.vars.cart = cart; 
          // }catch(err){
          //   console.error(err);
          // }

            geckoShopify.onItemAdded();
            // geckoShopify.GetCartData(0,0)

            

            
          
            // geckoShopify.onCartUpdate(0,0,cart.sections.cart_js);
        } catch (err) {
            console.error(err);
        }

        $($submitForm).removeClass('jn-loading');

        // Swal.close()

        // $.ajax({
        //     type: "POST",
        //     url: $($submitForm).attr('action'),
        //   cache: false,
        //     data: $($submitForm).serialize(),
        //      success: function(data){
        //                 //alert("Thank's For Submitting Your Email");
        //        console.log('post!')
        //             },
        // })
    });

if(false && ((window.location.href.includes('collection') || window.location.href.includes('product')))) {
  let bannerPlacement = '#nt_content'
  let placementMethod = 'prepend'
  if(jQuery('.type_slideshow').length > 0){
    bannerPlacement = '.type_slideshow'
    placementMethod = 'append'
  }
  let countToDate = '22-04-2025'
  
  // if(moment(countToDate, 'DD-MM-YYYY').diff(moment(), 'days') + 1 < 0){
  //   countToDate = '19-01-2025';
  // }
  
jQuery(bannerPlacement)[placementMethod](`
    <style>
        .jn-alert-banner {
            display: block;
            padding: 20px;
            background-color: #c08b50;
            border-radius: 6px;
            margin-top: 10px;
            padding-top: 15px;
            padding-bottom: 15px;
            text-decoration: none;
        }
        .jn-alert-banner p {
            margin: 0;
            line-height: 1.2;
            color: #fff;
            opacity: .8;
        }
        .jn-alert-banner .jn-alert-title {
            font-size: 24px;
            opacity: 1;
        }
        .jn-alert-banner .jn-alert-title span {
            display: inline-block;
            background-color: #fff;
            color: #5b7b69;
            padding: 2px 5px;
            border-radius: 6px;
            font-size: 20px;
            font-weight: bold;
            transform: translateY(-2px) translateX(1px);
        }
            @media screen and (max-width: 767px){
                .jn-alert-banner {
                    padding: 25px;
                    padding-top: 20px;
                    padding-bottom: 25px;
                }
                .jn-alert-banner .jn-alert-title {
                    margin-bottom: 11px;
                }
            }
    </style>
    <div class="shopify-section">
        <div class="container">
            <a href="/collections/aanbiedingen" class="jn-alert-banner">
                <p class="jn-alert-title">🐰🌻 Paasactie: 10% korting op nieuwe tafels! Nog <span class="jn-alert-counter">${moment(countToDate, 'DD-MM-YYYY').diff(moment(), 'days') + 1}</span> dagen te gaan.</p>
                <p>Deze Pasen hebben we écht mooie deals op geweldig nieuwe tafels en een paar oude vertrouwde banken en eetkamerstoelen. Geselecteerde tafels hebben een spectaculaire 10% korting. Kom naar de showroom voor korting op andere afmetingen.</p>
            </a>
        </div>
    </div>    

    
`)
}

  /*
      <div class="shopify-section">
        <div class="container">
            <a href="/collections/binnen-tafels/" class="jn-alert-banner">
                <p class="jn-alert-title">Nog <span class="jn-alert-counter">${moment(countToDate, 'DD-MM-YYYY').diff(moment(), 'days') + 1}</span> dagen tot de prijsverhoging op al onze tafels</p>
                <p>Per ${moment(countToDate, 'DD-MM-YYYY').format('D')} januari 2025 verhogen wij onze prijzen om de kwaliteit te blijven waarborgen. Bestel nu en bespaar!</p>
            </a>
        </div>
    </div> 
  */

  /*
      <div class="shopify-section">
        <div class="container">
            <a href="/pages/actie-overzicht" class="jn-alert-banner">
                <p class="jn-alert-title">Nog <span class="jn-alert-counter">${moment('09-12-2024', 'DD-MM-YYYY').diff(moment(), 'days') + 1}</span> dagen om jouw deal te scoren</p>
                <p>Black Friday Deals! Tijdelijk tot 15% korting op geselecteerde producten. Bestel nu online of bezoek onze showroom!</p>
            </a>
        </div>
    </div>    */

//   document.querySelector('dialog').addEventListener('mousedown', event => {
//     console.log('whoop')
//     if (event.target === event.currentTarget) {
//         event.currentTarget.close()
//     }
// })

  if($('html.article .post-content').length > 0){

    $('.page-head .container').hide()
    

    $('html.article .nt_single_blog').prepend(`
      <div class="post-content-head">
        ${$('.page-head .container').html()}
      </div>
    `)
    $('.page-head .container').html('')
    
    $('html.article .post-content .post a > img').each(function(index, $img){
      let $a = $($img).parent()
      $($a).addClass('blog-image-button-container')
      $($a).append(`
        <a class="btn" href="${$($a).attr('href')}">${$($a).attr('title')}</a>
      `)
    })
  }

  

  $('body').on('click', '.cookiefirst-root', function(event){
    if (event.target === event.currentTarget) {
        // event.currentTarget.close()
      $('.cookiefirst-root [data-cookiefirst-action="accept"]').trigger('click');
    }
    // $('.cookiefirst-root [data-cookiefirst-action="accept"]').trigger('click');
  })

  $('body').on('click', '.open-cookie-settings', function(e){
    e.preventDefault();
    CookieFirst.openPanel();
  })

  if(location.pathname.includes('blackfriday-2024')){
    $('body').on('click', '.jn-btn-samenstellen', function(e){
      new swal({
        html: `De actieprijzen zijn niet van toepassing op zelf samengestelde producten.`,
        confirmButtonText: 'Ga verder',
      })
    }) 
  }
});


window.Futy = { key: '67583f818d3a3' };
(function (e, t) {
    var n = e.createElement(t);
    n.async = true;
    var f = window.Promise && window.fetch ? 'modern.js' : 'legacy.js';
    n.src = 'https://v1.widget.futy.io/js/futy-widget-' + f;
    var r = e.getElementsByTagName(t)[0];
    r.parentNode.insertBefore(n, r);
})(document, 'script');


// 


window.dataLayer = window.dataLayer || [];
function gtag() {
    dataLayer.push(arguments);
}

function devmode() {
    localStorage.setItem('devmode', 1);
    window.location.reload();

    document.querySelector('body').classList.add('devmode');
}

function devmodeOff() {
    localStorage.setItem('devmode', 0);
    window.location.reload();
}

// var myRequestLog = []; // Using `var` (instead of `let` or `const`) so it creates an implicit property on the (global) `window` object so you can easily access this log from anywhere just by using `window.myRequestLog[...]`.
// function onRequestsObserved(batch) {
//     const xmlhttprequests = performance.getEntriesByType('resource').filter((entry) => {
//         return entry.initiatorType === 'xmlhttprequest';
//     });
//     myRequestLog.push(...xmlhttprequests);
//     // console.log(batch);
//     // myRequestLog.push(...batch.getEntries());
// }
// var requestObserver = new PerformanceObserver(onRequestsObserved);
// requestObserver.observe({ type: 'resource' /*, buffered: true */ });
// // requestObserver.observe({ type: 'resource', entryTypes: ['xmlhttprequest'] /*, buffered: true */ });

// const jnFetchObserver = new PerformanceObserver((list) => {
//     for (const entry of list.getEntries()) {
//         if (entry.initiatorType === 'fetch') {
//             console.log('Fetch request detected to', entry.name);
//             console.log(entry.toJSON());
//         }
//     }
// });

// jnFetchObserver.observe({
//     entryTypes: ['resource'],
// });

jQuery_T4NT(document).ready(function ($) {
    if (jnApp.dev) console.log('-> jn scripts loaded');
    /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */

    const urlSearchParams = new URLSearchParams(window.location.search);
    const urlParams = Object.fromEntries(urlSearchParams.entries());

    let app = {
        vars: {
            variantId: null,
            variantChangeCallbacks: [],
            menuRendered: false,
            devmode: localStorage.getItem('devmode') && localStorage.getItem('devmode') === '1' ? true : false,
            cartUpselling: {
                items: [
                    {
                        id: 'table_chair_1',
                        conditions: [
                            {
                                key: 'product_title',
                                value: 'eettafel',
                            },
                        ],
                        filterWords: ['eetkamerstoel'],
                        products: [
                            {
                                handle: 'eetkamerstoel-alyssa-swivel-draaibaar',
                            },
                            {
                                handle: 'eetkamerstoel-angel-bull-anthracithe-draaibaar-onderstel',
                            },
                            {
                                handle: 'eetkamerstoel-angel-bull-camel-draaibaar-onderstel',
                            },
                            {
                                handle: 'eetkamerstoel-angel-miami-dark-grey-draaibaar-onderstel',
                            },
                        ],
                    },
                ],
            },
        },
        init: async () => {
            try {
                if (typeof jnApp === 'undefined') return;
                if (!jnApp) return;

                if (app.vars.devmode) document.querySelector('body').classList.add('devmode');

                app.redirects();
                app.onbeforeunload();
                app.globalListeners();
                app.viewProductInStore.init();

                await app.packageBundle.init();
                await app.sidemenu.init();

                app.listenVariants();

                // app.cartUpsellingWidget.init();

                if (jnApp.dev) console.log('-> all apps inited');
            } catch (err) {
                console.error(err);
            }
        },
        globalListeners: () => {
            $(document).on('cart:update', async function (evt, variant) {
                await new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve();
                    }, 0);
                });

                let requestCart = await fetch(`/cart.js`, {
                    method: 'GET',
                    cache: 'no-cache',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                let cart = await requestCart.json();
                try {
                    // console.log('new cart...',{data})
                    jnApp.vars.cart = cart;
                } catch (err) {
                    console.error(err);
                }

                // console.log('CART UPDATE', evt, variant);
                // console.log({
                //     cart: jnApp.vars.cart,
                // });

                // if canrun
                app.cartUpsellingWidget.renderDiscounts();
            });

            $(document).on('variant:change', function (evt, variant) {
                //console.log( variant );
            });
        },
        cartUpsellingWidget: {
            init: () => {
                // if canrun
                app.cartUpsellingWidget.renderDiscounts();

                $('body').on('click', '.jn-cart-upselling-widget-submit', async function (e) {
                    e.preventDefault();
                    let formId = $(this).attr('data-form_id');

                    try {
                        if ($(`#${formId} .jn-cart-upselling-widget-submit`).hasClass('jn-btn-loading')) return;

                        if ($(`#${formId} input[name="id"]:checked`).length == 0) {
                            $(`#${formId}`).removeClass('jn-cart-upselling-widget-form-error');
                            setTimeout(function () {
                                $(`#${formId}`).addClass('jn-cart-upselling-widget-form-error');
                            }, 150);
                            return;
                        }

                        $(`#${formId} .jn-cart-upselling-widget-submit`).addClass('jn-btn-loading');

                        $(`#${formId}`).removeClass('jn-cart-upselling-widget-form-error');

                        let body = {
                            items: [
                                {
                                    id: $(`#${formId} input[name="id"]:checked`).val(),
                                    quantity: $(`#${formId} input[name="quantity"]`).val(),
                                },
                            ],
                        };

                        console.log(body);

                        let addToCartResult = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(body),
                        }).then((response) => {
                            return response.json();
                        });

                        geckoShopify.onItemAdded();
                    } catch (err) {
                        console.error(err);
                    }
                    $(`#${formId} .jn-cart-upselling-widget-submit`).removeClass('jn-btn-loading');
                });
            },
            renderDiscounts: () => {
                app.vars.cartUpselling.items.forEach((item) => {
                    app.cartUpsellingWidget.renderPart(item);
                });
            },
            renderPart: async (item) => {
                try {
                    let toClass = `jn-cart-discounts-${item.id}`;
                    if ($('.mini_cart_content_upseller').find(`.${toClass}`).length == 0) $('.mini_cart_content_upseller').append(`<div class="jn-cart-discounts ${toClass}"></div>`);

                    let canRun = false;

                    item.conditions.forEach((condition) => {
                        if (jnApp.vars.cart.items.find((cartItem) => cartItem[condition.key].toLowerCase().includes(condition.value.toLowerCase()))) canRun = true;
                    });

                    let productAlreadyAdded = jnApp.vars.cart.items.find((cartItem) => {
                        return item.products.find((product) => product.handle == cartItem.handle);
                    });

                    if (!canRun || productAlreadyAdded) {
                        $(`.${toClass}`).hide();
                        return;
                    }

                    $(`.${toClass}`).fadeIn();

                    for (let i = 0; i < item.products.length; i++) {
                        let product = item.products[i];
                        if (product.data) continue;

                        console.log({ product });
                        product.data = await fetch(`${window.Shopify.routes.root}products/${product.handle}.js`).then((response) => response.json());

                        product.title = product.data.title;

                        if (item.filterWords)
                            item.filterWords.forEach((word) => {
                                product.title = product.title.replace(new RegExp(word, 'ig'), '');
                            });
                    }

                    let formId = `upsell_form_product_${item.id}`;

                    console.log(item.products);

                    $(`.${toClass}`).html(`
                        <div id="${formId}" action="/cart/add" method="post" class="jn-cart-discounts-form variations_form">
                            <div class="jn-cart-upselling-widget-head">
                                <h3>Actie: Tafel met stoelen korting</h3>
                                <p>Ontvang <strong>5% korting</strong> op stoelen in combinatie met een tafel. Bekijk alle actie stoelen <a href="/collections/stoelen">hier</a>.</p>
                            </div>
                            <div class="jn-cart-upselling-widget-products">
                            ${item.products
                                .map(
                                    (product) => `
                                    <div class="jn-cart-upselling-widget-product">
                                        <input type="radio" name="id" value="${product.data.variants[0].id}" id="product_${item.id}_${product.data.variants[0].id}" />
                                        <label for="product_${item.id}_${product.data.variants[0].id}">
                                            <div class="jn-img-wrapper">
                                                <img src="${product.data.featured_image}" />
                                            </div>
                                            <div class="jn-cart-upselling-widget-product-title">${product.title}</div>
                                        </label>
                                    </div>
                            `
                                )
                                .join('')}

                            </div>
                            <div class="jn-button-row">
                                <div class="quantity pr qty__true" id="sp_qty_ppr"> 
                                    <input type="number" class="input-text qty text tc qty_pr_js" step="1" min="1" max="9999" name="quantity" value="4" size="4" pattern="[0-9]*" inputmode="numeric">
                                    <div class="qty tc fs__14"><button type="button" class="plus db cb pa pd__0 pr__15 tr r__0"><i class="facl facl-plus"></i></button><button type="button" class="minus db cb pa pd__0 pl__15 tl l__0"><i class="facl facl-minus"></i></button></div>
                                </div>
                                <button data-form_id="${formId}" class="btn jn-btn-primary jn-cart-upselling-widget-submit">Toevoegen</button>
                            </div>
                        </div>
                    `);
                } catch (err) {
                    console.error(err);
                }
            },
            shouldRender: () => {},
        },
        onbeforeunload: () => {
            window.onbeforeunload = function () {
                ////////////////////////////////
                // Prevent scroll on page reload
                if (window.location.href.includes('collections')) window.scrollTo(0, 0);
            };
        },
        redirects: () => {
            ////////////////////////////////
            // Block old configurator

            if (window.location.pathname.includes('/apps/configurator')) {
                window.location.href = 'https://kas20.nl/?open-configurator=tafel';
                Swal.fire({
                    html: `<h3>Doorverwijzen naar nieuwe configurator...</h3>`,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                    allowEnterKey: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            }
        },
        viewProductInStore: {
            init: () => {
                app.viewProductInStore.listen();
                app.viewProductInStore.printTimesHtml();
            },
            getTimesHtml: (storeId, type) => {
                return `
                    ${jnApp.vars.jnStores
                        .find((store) => store.id == storeId)
                        .times.map((time) => {
                            let canAdd = !time.types || (time.types && time.types.includes(type));
                            if (!canAdd) return '';

                            if (time.paragraph) return `<p>${time.paragraph}</p>`;
                            if (time.html) return `${time.html}`;
                            if (time.spacer) return `<div class="spacer my-1"></div>`;

                            let sublabel = time.sublabel ? `<span class="sublabel">${time.sublabel}</span>` : '';

                            let bold = false;
                            if (time.bold) bold = true;

                            return `<p><span class="${time.bold ? 'bold' : ''}">${time.label || ''}</span> ${time.time || ''}${sublabel}</p>`;
                        })
                        .join('')}
                `;
            },
            printTimesHtml: () => {
                $('div.print-jn-store').each(function (index, $el) {
                    let storeId = $($el).attr('data-store-id');
                    $($el).html(app.viewProductInStore.getTimesHtml(storeId, 'footer'));
                });

                $('a[href^="#opentimes"]').each(function (index, $el) {
                    // #opentimes_enschede-01
                    let href = $(this).attr('href');
                    let storeId = href.split('_')[1];
                    $($el).after(`
                        <div class="opentimes-anchor-placement">
                            <p><strong>Openingstijden</strong></p>
                            ${app.viewProductInStore.getTimesHtml(storeId, 'detail')}
                        </div>
                    `);
                    $($el).hide();
                    // $($el).html(app.viewProductInStore.getTimesHtml(storeId));
                });
            },
            listen: () => {
                $('body').on('click', '.jn-stores', function (e) {
                    let storeIds = $(this).attr('data-stores');
                    if (storeIds) {
                        storeIds = storeIds.split(',');
                        storeIds.push('maak-een-afspraak');
                    } else {
                        storeIds = ['de-kwakel-01', 'helmond-01', 'almere-01', 'enschede-01', 'maak-een-afspraak'];
                    }

                    let filterStores = jnApp.vars.jnStores;

                    if (storeIds && storeIds.length > 0) filterStores = jnApp.vars.jnStores.filter((a) => storeIds.includes(a.id) || storeIds.includes(a.label));

                    e.preventDefault();
                    Swal.fire({
                        width: 700,
                        confirmButtonColor: 'var(--primary)',
                        showCancelButton: true,
                        cancelButtonText: 'Sluiten',
                        html: `
                    <div class="jn-stores-container">
                      ${filterStores
                          .map((store) => {
                              return `
                                <div class="jn-store">
                                <div class="jn-store-image" style="background-image:url('${store.store_img}');"></div>
                                <div class="jn-store-content">
                                    <h2>${store.name}</h2>
                                    <div>${store.description}</div>
                                    <div class="jn-store-columns">
                                    <div>
                                        <h5>Openingstijden</h5>
                                        <p>${app.viewProductInStore.getTimesHtml(store.id, 'detail')}</p>
                                    </div>
                                    <div>
                                        <h5>Adres</h5>
                                        <p>${store.address}</p>
                                        <a class="jn-btn jn-btn-primary" href="${store.store_url}">Bezoek showroom &rarr;</a>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            `;
                          })
                          .join('')}
                    </div>
                  `,
                        reverseButtons: true,
                        confirmButtonText: 'Bekijk alle',
                    }).then((result) => {
                        if (result.isConfirmed) window.location.href = '/pages/showroom-bezoeken';
                    });
                });
            },
        },
        sidemenu: {
            init: () => {
                app.sidemenu.listen();
            },
            listen: () => {
                $('a[href="#open_sidemenu"]').on('click', function () {
                    app.sidemenu.open();
                });
            },
            open: () => {
                $('a[data-id="#nt_menu_canvas"]').trigger('click');
                // $('#nt_menu_canvas').addClass('act_opened')

                // _this.addClass('act_current');
                $('html').addClass('hside_opened');
                $('body').addClass('pside_opened');
                // $id.addClass('act_opened');
                $('.mask-overlay').addClass('mask_opened');

                $('#nt_menu_canvas').removeClass('lazyloadt4s');
                $('#nt_menu_canvas').addClass('lazyloadt4sed');

                // /search/?view=mn

                if (!app.vars.menuRendered) {
                    $('#nt_menu_canvas').load($('#nt_menu_canvas').data('rendert4s'));
                }

                app.vars.menuRendered = true;

                //nt_fk_canvas nt_sleft dn lazyloadt4sed act_opened
                //nt_fk_canvas nt_sleft dn lazyloadt4s act_opened
            },
        },
        listenVariants: () => {
            if (urlParams && urlParams.variant) {
                app.vars.variantId = urlParams.variant;
                app.setvariantPrice();
            }

            $(document).on('variant:changed', function (evt) {
                app.vars.variantId = evt.currentVariant.id;
                app.setvariantPrice();
                // $('[data-variant-toggle]').hide(0);
                // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
            });
        },
        setvariantPrice: () => {
            app.vars.variantChangeCallbacks.forEach((callback) => {
                if (typeof callback === 'function') callback(app.vars.variantId);
            });
        },
        getVariant: () => {
            try {
                let findVariant = jnApp.vars.product.data.variants.find((variant) => variant.id == app.vars.variantId);
                return findVariant;
            } catch (err) {
                return jnApp.vars.product.data;
            }
        },
        toCurrency: (amount) => {
            // let options = {
            //     amount: 0,
            //     isoCode: 'en-DE',
            //     currency: 'EUR',
            // }

            // let currency = Intl.NumberFormat(options.isoCode, {
            //     style: 'currency',
            //     currency: options.currency,
            // });

            let currency = Intl.NumberFormat(jnApp.vars.language.iso_code, {
                style: 'currency',
                currency: jnApp.vars.cart.currency,
            });

            return currency.format(amount / 100);
        },
        // template: {
        //     init: () =>
        //         new Promise(async (resolve, reject) => {
        //             try {
        //                 await app.template.canRun();
        //                 if (jnApp.dev) console.log(`-> template.init()`);

        //                 await app.template.listen();
        //                 await app.template.render();

        //                 resolve();
        //             } catch (err) {
        //                 if (err !== 'silent') console.error(err);
        //                 resolve();
        //             }
        //         }),
        //     canRun: () =>
        //         new Promise(async (resolve, reject) => {
        //             try {
        //                 resolve();
        //             } catch (err) {
        //                 reject(err);
        //             }
        //         }),
        //     listen: () =>
        //         new Promise(async (resolve, reject) => {
        //             try {
        //                 // listen stuff
        //                 $('xxx').on('click', function (e) {
        //                     e.preventDefault();
        //                     // do stuff
        //                 });

        //                 resolve();
        //             } catch (err) {
        //                 reject(err);
        //             }
        //         }),
        //     render: () =>
        //         new Promise(async (resolve, reject) => {
        //             try {
        //                 // render stuff

        //                 resolve();
        //             } catch (err) {
        //                 reject(err);
        //             }
        //         }),
        // },
        packageBundle: {
            init: () =>
                new Promise(async (resolve, reject) => {
                    try {
                        await app.packageBundle.canRun();
                        if (jnApp.dev) console.log(`-> packageBundle.init()`);

                        if ($('.jn-package-bundle-container').length == 0) {
                            $('.t4s-product-form__variants').append(`
                                <div class="jn-package-bundle-container"></div>
                            `);
                        }

                        app.vars.variantChangeCallbacks.push(() => {
                            let variant = app.getVariant();
                            app.packageBundle.renderInit();
                        });

                        // await app.packageBundle.renderInit();
                        await app.packageBundle.listen();

                        resolve();
                    } catch (err) {
                        if (err !== 'silent') console.error(err);
                        resolve();
                    }
                }),
            canRun: () =>
                new Promise(async (resolve, reject) => {
                    try {
                        if ($('.t4s-product__info-container').length == 0) throw 'silent';
                        if (jnApp.vars.product.packageBundleProducts.length == 0) throw 'silent';

                        resolve();
                    } catch (err) {
                        reject(err);
                    }
                }),
            listen: () =>
                new Promise(async (resolve, reject) => {
                    try {
                        // listen stuff
                        $('.jn-package-bundle-container').on('change', '.jn-package-bundle-product-toggle', function (e) {
                            e.preventDefault();

                            app.packageBundle.renderTotals();
                        });

                        $('.jn-package-bundle-container').on('click', '.jn-package-bundle-add', async function (e) {
                            e.preventDefault();
                            try {
                                if ($(this).hasClass('button--loading')) return;

                                let items = [];

                                let quantity = 1;

                                if ($('.jn-package-bundle-quantity').length > 0 && !isNaN($('.jn-package-bundle-quantity').val())) quantity = Number($('.jn-package-bundle-quantity').val());

                                $('.jn-package-bundle-product-toggle:checked').each(function (index, $el) {
                                    items.push({
                                        // id: Number($($el).attr('data-product-id')),
                                        id: index == 0 ? app.vars.variantId : Number($($el).attr('data-variant-id')),
                                        quantity,
                                    });
                                });

                                $('.jn-package-bundle-add').addClass('button--loading');

                                let addToCartResult = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        items,
                                    }),
                                }).then((response) => {
                                    return response.json();
                                });

                                // console.log(addToCartResult);

                                // let addToCartUrl = `/cart/${variantIds.map((id) => `${id}:1`).join(',')}`;

                                window.location.href = `${window.Shopify.routes.root}cart`;
                            } catch (err) {
                                console.error(err);
                                $('.jn-package-bundle-add').removeClass('button--loading');
                            }
                        });

                        resolve();
                    } catch (err) {
                        reject(err);
                    }
                }),
            renderProduct: ({ product, variant = null, index, disabled = false, addClass = '' }) => {
                // console.log({ variant });

                // if (!variant) {
                //     variant = {
                //         id: product.variants[0].id,
                //         price: product.variants[0].price,
                //         compare_at_price: product.variants[0].compare_at_price,
                //     };

                // }
                if (variant) {
                    product.price = variant.price;
                    if (variant.compare_at_price) product.compare_at_price = variant.compare_at_price;
                }

                return `
                    <${disabled ? `div` : `label`} for="jn-package-bundle-product_i_${index}" class="jn-package-bundle-product ${addClass}">
                        <div class="jn-package-bundle-product-check ${disabled ? `jn-package-bundle-product-check-disabled` : ``}">
                            <div class="checkbox-wrapper-14">
                                ${disabled ? `<i class="las la-check"></i>` : ``}
                                <input id="jn-package-bundle-product_i_${index}" type="checkbox" class="switch jn-package-bundle-product-toggle ${disabled ? 'none' : ''}" data-product-id="${
                    product.id
                }" data-variant-id="${variant ? variant.id : product.variants[0].id}" data-price="${product.price}" checked />
                            </div>
                        </div>
                        <div class="jn-package-bundle-product-image">
                            ${
                                product.featured_image
                                    ? `
                                <img src="${product.featured_image}" alt="${product.title}">
                            `
                                    : ``
                            }
                        </div>

                        <div class="jn-package-bundle-product-content">
                            <h4 class="jn-package-bundle-product-title">${product.title}</h4>
                            <div class="jn-package-bundle-product-price">
                                <!--<span class="current-price">${app.toCurrency(product.price)}</span>-->

                                <span class="jn-bundle-current-price current-price" data-already-discounted="${!!product.compare_at_price ? 1 : 0}" data-original-price="${
                    product.price
                }">${app.toCurrency(product.price)}</span>
                                ${!!product.compare_at_price ? `&nbsp;<span class="from-price">${app.toCurrency(product.compare_at_price)}</span>` : ``}

                                <!--<span class="current-price">${app.toCurrency(product.price)}</span> <span class="from-price">${app.toCurrency(product.compare_at_price)}</span>-->
                            </div>

                        </div>
                    </${disabled ? `div` : `label`}>
                `;
            },
            renderInit: () =>
                new Promise(async (resolve, reject) => {
                    try {
                        // render stuff
                        // $('.t4s-product__info-container').append(`

                        $('.jn-package-bundle-container').html(`<div class="jn-package-bundle">
                                ${
                                    jnApp.vars.product.packageBundleDiscountLabel
                                        ? `
                                <div class="jn-package-bundle-save-label">
                                    ${jnApp.vars.product.packageBundleDiscountLabel}
                                </div>
                                `
                                        : ``
                                }
                                ${
                                    jnApp.vars.product.packageBundleContent
                                        ? `
                                    <div class="jn-package-bundle-content">
                                        ${jnApp.vars.product.packageBundleContent}
                                    </div>
                                `
                                        : ``
                                }

                                <div class="jn-package-bundle-products">
                                    ${app.packageBundle.renderProduct({
                                        product: jnApp.vars.product.data,
                                        variant: app.getVariant(),
                                        index: '',
                                        disabled: true,
                                    })}

                                    <div class="jn-package-bundle-product-divider"></div>

                                    ${jnApp.vars.product.packageBundleProducts
                                        .map((product, index) =>
                                            app.packageBundle.renderProduct({
                                                product,
                                                index,
                                                addClass: 'jn-package-bundle-product-interactive',
                                            })
                                        )
                                        .join('')}
                                </div>

                                <div class="jn-package-bundle-summary"></div>

                                <div class="t4s-product-form__buttons" style="--pr-btn-round:0px;"> 
                                    <div class="t4s-d-flex t4s-flex-wrap">
                                        <div data-quantity-wrapper="" class="t4s-quantity-wrapper t4s-product-form__qty"> 
                                            <button data-quantity-selector="" data-decrease-qty="" type="button" class="t4s-quantity-selector is--minus"><svg focusable="false" class="icon icon--minus" viewBox="0 0 10 2" role="presentation"><path d="M10 0v2H0V0z" fill="currentColor"></path></svg></button>
                                            <input data-quantity-value="" type="number" class="t4s-quantity-input jn-package-bundle-quantity" step="1" min="1" max="9999" name="quantity" value="1" size="4" pattern="[0-9]*" inputmode="numeric">
                                            <button data-quantity-selector="" data-increase-qty="" type="button" class="t4s-quantity-selector is--plus"><svg focusable="false" class="icon icon--plus" viewBox="0 0 10 10" role="presentation"><path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path></svg></button>
                                        </div>
                                        <button class="jn-package-bundle-add   t4s-btn t4s-btn-base t4s-btn-style-default t4s-btn-color-dark t4s-w-100 t4s-justify-content-center  t4s-btn-effect-sweep-to-top t4s-btn-loading__svg">
                                            <svg class="t4s-btn-icon" viewBox="0 0 24 24"><use xlink:href="#t4s-icon-atc"></use></svg>
                                            <div class="jn-package-bundle-totals"></div>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        `);

                        app.packageBundle.renderTotals();

                        resolve();
                    } catch (err) {
                        reject(err);
                    }
                }),
            renderTotals: () => {
                let totalPrice = 0;
                let discountPrice = 0;
                let totalOptionsCount = $('.jn-package-bundle-product-toggle').length;
                let checkedOptionsCount = $('.jn-package-bundle-product-toggle:checked').length;
                let addDiscount = totalOptionsCount === checkedOptionsCount;

                // calc total price
                $('.jn-package-bundle-product-toggle:checked').each(function (index, $el) {
                    let price = Number($($el).attr('data-price'));

                    if (index == 0) {
                        let mainProduct = app.getVariant();
                        console.log({ mainProduct });
                        price = mainProduct.price;
                    }

                    totalPrice = totalPrice + price;
                });

                discountPrice = totalPrice;

                console.log({ discountPrice, totalPrice, addDiscount });

                if (addDiscount) {
                    if (jnApp.vars.product.packageBundleDiscountType == 'percentage') discountPrice = totalPrice * ((100 - Number(jnApp.vars.product.packageBundleDiscountAmount)) / 100);
                    if (jnApp.vars.product.packageBundleDiscountType == 'amount') discountPrice = totalPrice - Number(jnApp.vars.product.packageBundleDiscountAmount) * 100;
                    // if (jnApp.vars.product.packageBundleDiscountType == 'amount') discountPrice = totalPrice - Number('69.9') * 100;

                    let discountDiff = totalPrice - discountPrice;

                    if (discountDiff > 0) {
                        // let itemDiff = discountDiff / (checkedOptionsCount - 1);
                        let itemDiff = discountDiff / checkedOptionsCount;

                        $('.jn-bundle-current-price').each(function (index, $el) {
                            let originalItemPrice = Number($($el).attr('data-original-price'));
                            let isAlreadyDiscounted = Number($($el).attr('data-already-discounted'));

                            let newPrice = originalItemPrice - itemDiff;

                            if (isAlreadyDiscounted) {
                                $($el).html(`${app.toCurrency(newPrice)}`);

                                return;
                            }

                            $($el).html(`${app.toCurrency(newPrice)}&nbsp;<span class="from-price">${app.toCurrency(originalItemPrice)}</span>`);
                        });
                    }
                } else {
                    $('.jn-bundle-current-price').each(function (index, $el) {
                        let originalItemPrice = Number($($el).attr('data-original-price'));

                        $($el).html(`${app.toCurrency(originalItemPrice)}`);
                    });
                }

                $('.jn-package-bundle-totals').html(`
                        <div class="jn-package-bundle-totals-price">
                            ${jnApp.vars.language.jn_package_bundle.total}
                            <!--&nbsp;<span class="current-price">${app.toCurrency(discountPrice)}</span>
                            ${addDiscount ? `&nbsp;&nbsp;<span class="from-price">${app.toCurrency(totalPrice)}</span>` : ``}-->
                        </div>
                `);

                $('.jn-package-bundle-summary').html(`
                    <div class="jn-package-bundle-summary-title">${jnApp.vars.language.jn_package_bundle.summary_total}:</div>
                    <div class="jn-package-bundle-summary-content">
                        ${addDiscount ? `&nbsp;<span class="from-price">${app.toCurrency(totalPrice)}</span>` : ``}
                        <span class="current-price">${app.toCurrency(discountPrice)}</span>
                    </div>
                `);
            },
        },
    };

    app.init();
});